import { mockBuilder } from '../../utils/builderHelper.es.js';
import '../../enums/billing/AccountGlobalStatusEnum.es.js';
import '../../enums/billing/AccountingStatusEnum.es.js';
import '../../enums/billing/AssetPurchaseFormatEnum.es.js';
import '../../enums/billing/AssetPurchaseUnavailableCodeEnum.es.js';
import '../../enums/billing/BillingSystemEnum.es.js';
import '../../enums/billing/CreditKindEnum.es.js';
import '../../enums/billing/InvoiceStatusEnum.es.js';
import '../../enums/billing/DiscountTypeEnum.es.js';
import { PlanFrequencyEnum } from '../../enums/billing/PlanFrequencyEnum.es.js';
import '../../enums/billing/ServiceOffersKindEnum.es.js';
import '../../enums/billing/ServiceStatusEnum.es.js';
import { SubscriptionStatusEnum } from '../../enums/billing/SubscriptionStatusEnum.es.js';
import '../../enums/billing/SubscriptionMigrationTypeEnum.es.js';
import '../../enums/billing/SubscriptionMigrationTimingEnum.es.js';
import { SubscriptionServiceOfferEnum } from '../../enums/billing/SubscriptionServiceOfferEnum.es.js';
import '../../enums/billing/BillingCommitmentEnum.es.js';
import '../../enums/collaboration/ActorEnum.es.js';
import '../../enums/collaboration/EntityTypeEnum.es.js';
import '../../enums/AppHomePageEnum.es.js';
import '../../enums/ApplicationEnum.es.js';
import '../../enums/CreditCardEnum.es.js';
import '../../enums/DollarSignCurrenciesEnum.es.js';
import '../../enums/DownloadBinStatusEnum.es.js';
import '../../enums/ExternalTypeEnum.es.js';
import '../../enums/FeatureEnum.es.js';
import '../../enums/FeatureFlagEnum.es.js';
import '../../enums/FileSelectionSourceEnum.es.js';
import '../../enums/GenresEnum.es.js';
import '../../enums/IntensityEnum.es.js';
import '../../enums/InternalErrorEnum.es.js';
import '../../enums/LibraryItemEnum.es.js';
import '../../enums/MasteringStyleEnum.es.js';
import '../../enums/MfeApplicationEnum.es.js';
import '../../enums/NotificationTypeEnum.es.js';
import '../../enums/PaymentCycleEnum.es.js';
import '../../enums/PaymentMethodEnum.es.js';
import '../../enums/ProofOfRightsEnums.es.js';
import '../../enums/RegexPatternsEnum.es.js';
import '../../enums/ReleaseContributorRoleEnum.es.js';
import '../../enums/ReleaseGlobalStateEnum.es.js';
import '../../enums/ReleaseLanguagesEnum.es.js';
import '../../enums/ReleasePayoutStatusEnum.es.js';
import '../../enums/ReleasePayoutGlobalStatusEnum.es.js';
import '../../enums/ReleaseStateEnum.es.js';
import '../../enums/ServiceProviderStateEnum.es.js';
import '../../enums/ReleaseStoreCategoryEnum.es.js';
import '../../enums/ReleaseStoreEnum.es.js';
import '../../enums/ReleaseTerritoriesEnum.es.js';
import '../../enums/ReleaseParentalWarningEnum.es.js';
import '../../enums/SessionFlagsEnum.es.js';
import '../../enums/ShareReactionTypeEnum.es.js';
import '../../enums/SocialNetworksEnum.es.js';
import '../../enums/StateEnum.es.js';
import '../../enums/TrackTypeEnum.es.js';
import '../../enums/UnavailabilityEnum.es.js';
import '../../enums/UserInteractionSourceEnum.es.js';
import '../../enums/ZeroDecimalCurrenciesEnum.es.js';
import '../../enums/NoiseReductionLevelEnum.es.js';
import '../../enums/ReleaseDspsEnum.es.js';
import '../../enums/ReleaseDspStatusEnum.es.js';
import '../../enums/ProjectsCallSourceTypesEnum.es.js';
import '../../enums/LibraryItemTypeEnum.es.js';
import '../../enums/PendingItemStateEnum.es.js';
import '../../enums/MonetizationEligibilityStateEnum.es.js';
import '../../enums/CoverSongOptionsEnum.es.js';
import '../../enums/LanguagesEnum.es.js';
import '../../enums/LocalesEnum.es.js';
import { Plan, Subscription, SubscriptionNext } from './Subscription.es.js';

/** @module Mocks */ /** typedoc */
function aPlan() {
    return mockBuilder(new Plan()).withCode('basic').withFrequency(PlanFrequencyEnum.Monthly);
}
// Will be removed later in a dedicated PR as this will require a lot of changes in Webapp
function aSubscription() {
    return mockBuilder(new Subscription())
        .withCode('advanced')
        .withServiceOffer(SubscriptionServiceOfferEnum.Mastering)
        .withFrequency(PlanFrequencyEnum.Monthly)
        .withStatus(SubscriptionStatusEnum.Active)
        .withEndDate(null)
        .withRenewalDate('2022-12-11T05:00:00Z');
}
function aSubscriptionSamples() {
    return mockBuilder(new Subscription())
        .withCode('samples_tier2')
        .withServiceOffer(SubscriptionServiceOfferEnum.Samples)
        .withFrequency(PlanFrequencyEnum.Monthly)
        .withStatus(SubscriptionStatusEnum.Active)
        .withEndDate(null)
        .withRenewalDate('2065-12-11T05:00:00Z');
}
function aSubscriptionMastering() {
    return mockBuilder(new Subscription())
        .withCode('mastering_advanced')
        .withServiceOffer(SubscriptionServiceOfferEnum.Mastering)
        .withFrequency(PlanFrequencyEnum.Monthly)
        .withStatus(SubscriptionStatusEnum.Active)
        .withEndDate(null)
        .withRenewalDate('2065-12-11T05:00:00Z');
}
function aSubscriptionDistribution() {
    return mockBuilder(new Subscription())
        .withCode('distribution_pro')
        .withServiceOffer(SubscriptionServiceOfferEnum.Distribution)
        .withFrequency(PlanFrequencyEnum.Yearly)
        .withStatus(SubscriptionStatusEnum.Active)
        .withEndDate(null)
        .withRenewalDate('2065-12-11T05:00:00Z');
}
function aSubscriptionSessions() {
    return mockBuilder(new Subscription())
        .withCode('sessions_premium')
        .withServiceOffer(SubscriptionServiceOfferEnum.Sessions)
        .withFrequency(PlanFrequencyEnum.Yearly)
        .withStatus(SubscriptionStatusEnum.Active)
        .withEndDate(null)
        .withRenewalDate('2065-12-11T05:00:00Z');
}
function aSubscriptionMasteringNext() {
    return mockBuilder(new SubscriptionNext())
        .withCode('mastering_advanced')
        .withFrequency(PlanFrequencyEnum.Monthly)
        .withStartDate('2019-05-10T04:00:00Z');
}
function aSubscriptionDistributionNext() {
    return mockBuilder(new SubscriptionNext())
        .withCode('distribution_pro')
        .withFrequency(PlanFrequencyEnum.Yearly)
        .withStartDate('2019-05-10T04:00:00Z');
}
function aSubscriptionSessionsNext() {
    return mockBuilder(new SubscriptionNext())
        .withCode('sessions_pro')
        .withFrequency(PlanFrequencyEnum.Yearly)
        .withStartDate('2019-05-10T04:00:00Z');
}

export { aPlan, aSubscription, aSubscriptionDistribution, aSubscriptionDistributionNext, aSubscriptionMastering, aSubscriptionMasteringNext, aSubscriptionSamples, aSubscriptionSessions, aSubscriptionSessionsNext };
